import config from "../../../config/app-config";
import Resizer from 'react-image-file-resizer';
import React from 'react';
import { Flex, Box, Image, Text, Link } from "@chakra-ui/react";
import ShortLogo from '../../global/styles/images/launchdeck-short-logo-icon.png';
import { displayEmoji } from "../../digital-sales-room/helpers/dsr-helpers";
import appConfig from "../../../config/app-config";
import LaunchdeckTag from "../components/helper-components/components/LaunchdeckTag";


// Basic 
export function isValidArray(arr) {
  return Array.isArray(arr) && arr.length > 0 && arr.some(item => item !== null && item !== undefined);
}

export function validateEmail(emailField) {
  if (!emailField || typeof emailField !== "string") return false; 

  const trimmedEmail = emailField.trim();
  const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return Boolean(
    trimmedEmail &&
    reg.test(trimmedEmail)
  );
}

export function validateUrlFormat(urlText) {

  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=_-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator


  return !!pattern.test(urlText);
}

export function displayModeCheck() {
  const { tabletWidthBreakpoint } = config;
  const isMobileView = (window.innerWidth < tabletWidthBreakpoint) ? true : false;

  return isMobileView;
}

export function reloadPage() {
  window.location.reload();
}

export function routeToUnexpectedLoggedInErrorPage() {
  window.location.href = "/invalid";
}

export function routeToDashboardPage() {
  window.location.href = "/home";
}

export function redirectToNewPage(routeLink) {
  window.location.href = `${routeLink}`
}

export function redirectToLandingPage() {
  window.location.href = appConfig.landingPage
}


//Generate Random Key (For ES6 Map)
export function getRandomKey() {
  return Math.random().toString(36).substr(2, 5);
}

export function getThisUserIdToken() {
  return localStorage.getItem('USER_ID_TOKEN');
}

export function generateSessionId() {
  return 'ses__' + generateRandomString(10)
}


// Single Layer Filter with single Criteria
export function filterTemplateArray(retrievedAllAgreementTemplates, filters) {
  const { genericTemplates, restrictedTemplates } = retrievedAllAgreementTemplates || {};
  const isOrgTemplates = (filters === 'restricted') ? true : false;

  const getValue = value => (typeof value === 'string' ? value.toLowerCase() : value);


  if (!retrievedAllAgreementTemplates || (!genericTemplates && !restrictedTemplates)) {
    return [];
  }

  if (isOrgTemplates && restrictedTemplates) {
    return restrictedTemplates.filter(item => {
      return item;
    });
  } else if (!filters) {
    return genericTemplates.filter(item => {
      return item;
    });
  } else {

    return genericTemplates.filter(item => {
      const templateTags = item.templateTags;

      return templateTags.find(tag => getValue(tag) === getValue(filters));
    });
  }

}


// Resize Images
export function resizeImage(file) {

  return new Promise((resolve, reject) => {
    Resizer.imageFileResizer(
      file,
      100,
      100,
      'JPEG',
      100,
      0,
      uri => {
        resolve(uri);
      },
      'blob',
      100,
      100,
    );
  })

}

export function resizeLogoImage(file) {

  return new Promise((resolve, reject) => {
    Resizer.imageFileResizer(
      file,
      200,
      200,
      'JPEG',
      100,
      0,
      uri => {
        resolve(uri);
      },
      'blob',
      200,
      200,
    );
  })

}

export function resizeBannerImage(file) {
  return new Promise((resolve, reject) => {
    Resizer.imageFileResizer(
      file,
      1120,
      160,
      'JPEG',
      100,
      0,
      uri => {
        resolve(uri);
      },
      'blob',
      1120,
      160,
    );
  })

}


// Parse Youtube links to Youtube embed links
export function getYoutubeEmbedLink(url) {
  // const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  const match = url.match(youtubeRegex);
  if (match && match[1]) {
    const videoId = match[1];
    const urlParams = new URLSearchParams(new URL(url).search);
    const startTime = urlParams.get('t');
    const timeMatch = startTime ? startTime.match(/(\d+)s?/) : "";
    const scrubbedSTartTime = timeMatch ? parseInt(timeMatch[1]) : "";
    let embedUrl = `https://www.youtube.com/embed/${videoId}?controls=1&iv_load_policy=3&showinfo=0`;

    if (scrubbedSTartTime) {
      embedUrl += `&start=${scrubbedSTartTime}`;
    }

    return embedUrl;
  }
}


// Open new tab
export function openInNewTab(url) {

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https://' + url;
  }

  window.open(url, '_blank')
}

// Formats link
export function formatHttpLinks(url) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url;
  } else {
    return url
  }
}

// Generate random strings
export function generateRandomString(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// Copy text to user clipboard
export function copyToUserClipboard(textContent) {
  return navigator.clipboard.writeText(textContent)
}

// UX formatting
export function displayMoney(currency, numberValue) {
  if (currency && Number.isInteger(numberValue)) {
    return new Intl.NumberFormat('en-US', { style: 'currency', minimumFractionDigits: 0, currency: currency }).format(numberValue);
  } else if (!currency && Number.isInteger(numberValue)) {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 }).format(numberValue);
  } else return "";
}

// Toast
export function triggerLaunchdeckToast({ useCase, isMobileView, bannerText, label, duration, link, linkText }) {

  switch (useCase) {
    case ("show-error-state"): {
      const displayedErrorMessage = label ? label : "Unfortunately something went wrong. Please try again later.";

      if (isMobileView) {
        return {
          position: 'bottom',
          duration: duration ? duration : 3600,
          isClosable: true,
          render: () => (
            <Flex m={8} rounded='0.5em' className="default-box-shadow" w='100%'>
              <Box rounded='0.5em' bg='pink.300' w='100%'>
                <Flex textAlign='center' justify='center' w='100%' px='1em' py='0.5em' fontSize='0.875em' color='white'>  {displayedErrorMessage} </Flex>
              </Box>
            </Flex>
          ),
        }
      } else {
        return {
          position: 'bottom-right',
          duration: 3600,
          isClosable: true,
          render: () => (
            <Box m={8} rounded='0.5em' className="default-box-shadow">
              <Flex className="toast-banner" bg='gray.700' color='white'>
                {displayEmoji('warning')}
                <Text textAlign='left' ml='0.5em' fontSize='0.875em' fontWeight='600' color='brandDark.500'>{bannerText ? bannerText : 'Something went wrong'}</Text>
              </Flex>
              <Box roundedBottomLeft='0.5em' roundedBottomRight='0.5em' bg='white'>
                <Text textAlign='left' color='gray.700' px='1em' py='0.5em' fontSize='0.875em'> {displayedErrorMessage} </Text>
              </Box>
            </Box>
          ),
        }
      }
    }
    case ("work-in-progress-state"): {
      const displayedWipMessage = label ? label : "We are working on it";

      if (isMobileView) {
        return {
          position: 'bottom',
          duration: duration ? duration : 3600,
          isClosable: true,
          render: () => (
            <Flex m={8} rounded='0.5em' className="default-box-shadow" w='100%'>
              <Box rounded='0.5em' bg='pink.300' w='100%'>
                <Flex textAlign='center' justify='center' w='100%' px='1em' py='0.5em' fontSize='0.875em' color='white'>  {displayedWipMessage} </Flex>
              </Box>
            </Flex>
          ),
        }
      } else {
        return {
          position: 'bottom-right',
          duration: 3600,
          isClosable: true,
          render: () => (
            <Box m={8} rounded='0.5em' className="default-box-shadow">
              <Flex className="toast-banner" bg='gray.700' color='white'>
                {displayEmoji('gear')}
                <Text textAlign='left' ml='0.5em' fontSize='0.875em' fontWeight='600' color='brandDark.500'>{bannerText ? bannerText : 'We are working on it'}</Text>
              </Flex>
              <Box roundedBottomLeft='0.5em' roundedBottomRight='0.5em' bg='white'>
                <Text textAlign='left' color='gray.700' px='1em' py='0.5em' fontSize='0.875em'> {displayedWipMessage} </Text>
              </Box>
            </Box>
          ),
        }
      }
    }
    case ("show-success-state"):
    default: {
      // Including success state
      const displayedSuccessMessage = label ? label : "Successful!"
      if (isMobileView) {
        return {
          position: 'bottom',
          duration: duration ? duration : 3600,
          isClosable: true,
          render: () => (
            <Flex m={8} rounded='0.5em' className="default-box-shadow" w='100%'>
              <Box rounded='0.5em' bg='green.500' w='100%'>
                <Flex textAlign='center' justify='center' w='100%' px='1em' py='0.5em' fontSize='0.875em' color='white'>  {displayedSuccessMessage} </Flex>
              </Box>
            </Flex>
          ),
        }
      } else {
        return {
          position: 'bottom-right',
          duration: duration ? duration : 3600,
          isClosable: true,
          render: () => (
            <Box m={8} rounded='0.5em' className="default-box-shadow">
              <Flex className="toast-banner">
                <Image src={ShortLogo} boxSize="0.9em" objectFit="cover" alt="Launchdeck Short Logo" />
                <Text textAlign='left' color='brandDark.500' ml='0.5em'>{bannerText ? bannerText : 'Success'}</Text>
              </Flex>
              <Box roundedBottomLeft='0.5em' roundedBottomRight='0.5em' bg='white'>
                <Text textAlign='left' color='gray.700' px='1em' py='0.5em' fontSize='0.875em'> {displayedSuccessMessage} </Text>
                {(linkText && link) &&
                <Flex  p='0.1em 0.25em'>
                  <Box ml='0.5em' mb='0.5em'>
									<LaunchdeckTag bg='#29ABE2' color='white' label={linkText}  cursor='pointer' onClick={()=> redirectToNewPage(link)}/>
								</Box>
                </Flex>

                }
              </Box>
            </Box>
          ),
        }
      }
    }
  }


}


// Check if dismissed banner
export function checkIfDismissedBanner(userSettings, bannerTypeValue) {
  const { userBannerSettings } = userSettings || {}
  const { dismissedBanners } = userBannerSettings || {};

  if (Array.isArray(dismissedBanners)) {
    const hasObjectWithFieldValue = dismissedBanners.some(obj => obj["bannerType"] === bannerTypeValue);
    return hasObjectWithFieldValue
  } else {
    return false
  }

}

// Searching array of objects
export function searchArrayofObjects(array, searchString, propertiesArray) {
  return array.filter(obj =>
    propertiesArray.some(property =>
      obj[property] && obj[property].toString().toLowerCase().includes(searchString.toLowerCase())
    )
  );
}

export function detectEmbedType(code) {
  if (code) {
    if (code.includes('<script') && code.includes('</script>')) {
      return 'script';
    } else if (code.includes('<iframe') && code.includes('</iframe>')) {
      return 'iframe';
    } else if (code.startsWith('<div class="iframely')) {
      return 'iframely';
    }
    return 'unknown';
  }

  return 'unknown';
}

export function extractIframeSrc(code) {
  const match = code.match(/<iframe[^>]*src="([^"]*)"[^>]*>/);
  return match ? match[1] : '';
}

export function renderTextWithWorkingLinks(text) {

  if (text && !isQuillDeltaFormat(text)) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex); // Split the text based on the URL regex
    return parts.map((part, index) => {
      // If the part matches the URL regex, render it as a Chakra Link
      if (urlRegex.test(part)) {
        return (
          <Link key={index} href={part}
            fontStyle="italic"
            rel="noopener noreferrer nofollow"
            target="_blank"
            color='brand.600'
            isExternal>
            {part}
          </Link>
        );
      }
      // Otherwise, render it as normal text
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  } else {

    return ""
  }
}

export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else return ""
}

export function truncateMobileDsrTitle(dsrTitle) {
  let processedTitle = dsrTitle
  const maxLength = 50;
    if (processedTitle?.length > maxLength) {
      return processedTitle.slice(0, maxLength) + '...';
    }
    return processedTitle;  
}

export function checkIfInteger(value) {
  const trimmedValue = parseInt(value.trim());
  const isInteger = Number.isInteger(trimmedValue)

  return {checkedValue: trimmedValue, isInteger}
}

export function validateHexColor(input) {

  if (!input) {
    return null
  } 

  // Add `#` if it's not already present
  if (input[0] !== '#') {
    input = `#${input}`;
  } 

   // Validate the input (must have # followed by 3 or 6 valid hex characters)
   if (input.length === 4 || input.length === 7) {
    const hexColorRegex = /^[a-fA-F0-9]{3}$/i; // 3-character hex color or 6-character hex color
    const hexColorRegex6 = /^[a-fA-F0-9]{6}$/i;

    // Ensure proper format: 3 or 6 characters after the #
    if (input.length === 4 && hexColorRegex.test(input.slice(1))) {
      return input.trim(); // Valid 3-character shorthand hex color
    } else if (input.length === 7 && hexColorRegex6.test(input.slice(1))) {
      return input.trim(); // Valid 6-character hex color
    }
  }

  return null; // Return null if the input is invalid
}

export function isQuillDeltaFormat(content) {
  return (
    content &&
    typeof content === 'object' &&
    Array.isArray(content.ops) && // Check if `ops` is an array
    content.ops.every(op => typeof op === 'object' && 'insert' in op) // Ensure every `op` has an `insert` property
  );
}

// TODO: For backward compatibility. Aim is to convert all to Quill format so that the checks don't need to happen all the time anymore. 
export function convertToQuillDelta(content) {
  if (content) {
    if (isQuillDeltaFormat(content)) {
      // If already in Delta format, return it as is
      return content;
    } else if (typeof content === 'string') {
      // If plain text, wrap it in Delta format
      return {
        ops: [{ insert: content }]
      };
  
    } else if (typeof content === 'string' && /<\/?[a-z][\s\S]*>/i.test(content)) {
      // If HTML, strip tags and wrap the text content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = content; // Use the browser to parse and extract plain text
      
      return {
        ops: [{ insert: tempDiv.textContent || "" }]
      };
    } else {
      // Unsupported formats: Return an empty Delta
      // return { ops: [] };
      return ""
    }
  } else {
    return ""
  }
  
}

export function formatQuillContentLinks(deltaContent) {
  let updatedDeltaContent = {...deltaContent};
  
  if (isQuillDeltaFormat(updatedDeltaContent)) {
    const ops = updatedDeltaContent.ops;
    ops.forEach(op => {
      if (op.attributes?.link) {
        op.attributes.link = formatHttpLinks(op.attributes.link)
      }
    });

    updatedDeltaContent.ops = ops;
  }


  return updatedDeltaContent;
}

export function hasQuillTextContent(content) {
  if (!content) {
    return false
  }

  if (content) {
    if (typeof content === "string") {
      return (content?.trim().length > 0)
    } else if (typeof content === "object") {

      return content?.ops?.some(op => {
        if (op.insert && typeof op.insert === 'string') {
          // Remove whitespace characters and check if there's anything left
          return op.insert.trim().length > 0;
        }
        return false;
      });
    } else return false; // fallback for other types
  }
};

export function waitForElement(selector, timeout = 3000) {
  return new Promise((resolve, reject) => {
    const interval = 100;
    let elapsed = 0;

    const check = () => {
      if (document.querySelector(selector)) {
        resolve();
      } else if (elapsed >= timeout) {
        reject(new Error(`Timeout: Element ${selector} not found`));
      } else {
        elapsed += interval;
        setTimeout(check, interval);
      }
    };

    check();
  });
};
// Timeout timers
// export function timeoutTool(timeInMilliseconds, callbackFunction) {
//   if (Number.isInteger(timeInMilliseconds)) {
//     return setTimeout(() => {
//       // After 3 seconds set the show value to false
//       callbackFunction()
//     }, timeInMilliseconds)
//   }
// }